(function () {
  function initSteps(section) {
    var tabs = section.querySelectorAll('[data-steps-tab]');
    var panels = section.querySelectorAll('[data-steps-panel]');
    var medias = section.querySelectorAll('[data-steps-media]');
    var headings = section.querySelectorAll('[data-steps-heading]');
    var bgLayer = section.querySelector('[data-steps-bg-layer]');
    var progress = section.querySelector('[data-steps-progress]');
    var progressFill = section.querySelector('[data-steps-progress-fill]');

    function updateProgress(index) {
      if (!progress || !progressFill || !tabs.length) return;
      var firstRect = tabs[0].getBoundingClientRect();
      var lastRect = tabs[tabs.length - 1].getBoundingClientRect();
      var activeRect = tabs[index].getBoundingClientRect();
      progress.style.width = (lastRect.right - firstRect.left) + 'px';
      progressFill.style.width = (activeRect.right - firstRect.left) + 'px';
    }

    function activate(index) {
      tabs.forEach(function (tab) {
        var active = parseInt(tab.dataset.stepsTab, 10) === index;
        tab.classList.toggle('steps__tab--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) {
          if (tab.dataset.stepsBg) {
            section.style.setProperty('--steps-stop-color', tab.dataset.stepsBg);
          }
          if (bgLayer) {
            bgLayer.hidden = tab.dataset.stepsGradient !== 'true';
          }
        }
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('steps__panel--active', parseInt(panel.dataset.stepsPanel, 10) === index);
      });
      medias.forEach(function (media) {
        media.classList.toggle('steps__media--active', parseInt(media.dataset.stepsMedia, 10) === index);
      });
      headings.forEach(function (heading) {
        heading.classList.toggle('steps__heading--active', parseInt(heading.dataset.stepsHeading, 10) === index);
      });
      updateProgress(index);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(parseInt(tab.dataset.stepsTab, 10));
      });
    });

    updateProgress(0);
  }

  document.querySelectorAll('[data-steps-section]').forEach(initSteps);
})();